import React, { useEffect, useRef } from 'react';
import './Members.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import FadeInSection from '../components/FadeInSection';

const membersData = {
  faculty: [
    {
      name: 'Dr. Mahendra Prasad Agasty',
      role: 'President, IIC',
      img: require('../assets/Agasthy.webp'),
    },
    {
      name: 'Dr. Sudhansu Mohan Biswal',
      role: 'Faculty In-Charge, SIPC',
      img: require('../assets/Sudhanshu.webp'),
    },
    {
      name: 'Er. Satish Kumar Das',
      role: 'Faculty Co-ordinator, SIPC',
      img: require('../assets/Satish1.webp'),
    }
  ],
  fourthYear: [
    {
      name: 'Pranay Mishra',
      role: 'Secretary',
      img: require('../assets/Pranay_Mishra.webp'),
    },
    {
      name: 'Smruti Ranjan Rout',
      role: 'Nominated Representative',
      img: require('../assets/SMRUTI_RANJAN_ROUT.webp'),
    },
    {
      name: 'Jagat Jyoti Behera',
      role: 'Joint Secretary',
      img: require('../assets/Jagat.webp'),
    },
    {
      name: 'Nirmalya Parida',
      role: 'Core Member',
      img: require('../assets/SKM_2217.webp'),
    },
    {
      name: 'Manoj Kumar Senapati',
      role: 'Core Member',
      img: require('../assets/Manoj_Kumar_Senapati.webp'),
    },
    {
      name: 'Sumeet Kumar Rout',
      role: 'Core Member',
      img: require('../assets/SUMEET_KUMAR_ROUT.webp'),
    },
    {
      name: 'Abinash Nanda',
      role: 'Core Member',
      img: require('../assets/Abinash_Nanda.webp'),
    },
    {
      name: 'Akankshya Hota',
      role: 'Core Member',
      img: require('../assets/Akankshya_Hota.webp'),
    },
    {
      name: 'Amarjyoti Senapati',
      role: 'Core Member',
      img: require('../assets/Amarjyoti_Senapati.webp'),
    },
    {
      name: 'Nirmalya Sahoo',
      role: 'Core Member',
      img: require('../assets/Nirmalya_sahoo.webp'),
    },
    {
      name: 'Piush Praharaj',
      role: 'Core Member',
      img: require('../assets/Piush_Praharaj.webp'),
    },
    {
      name: 'Arnav Pattnayak',
      role: 'Core Member',
      img: require('../assets/Arnav.webp'),
    },
    {
      name: 'Priyabrat Omm Kumar',
      role: 'Core Member',
      img: require('../assets/Priyabrat_Omm_Kumar.webp'),
    },
    {
      name: 'Sadiqua Farheen',
      role: 'Core Member',
      img: require('../assets/SADIQUA_FARHEEN.webp'),
    },
    {
      name: 'Sourav Subhakanta Dash',
      role: 'Core Member',
      img: require('../assets/SouravSubhakantaDash.webp'),
    },
  ],
  thirdYear: [
    {
      name: 'Anish Aniket',
      role: 'Core Member',
      img: require('../assets/Anish Aniket.webp'),
    },
    {
      name: 'Debasish Majhi',
      role: 'Core Member',
      img: require('../assets/DEBASISH MAJHI.webp'),
    },
    {
      name: 'Jayshree Padhi',
      role: 'Core Member',
      img: require('../assets/Jayshree padhi.webp'),
    },
    {
      name: 'Megha Patro',
      role: 'Core Member',
      img: require('../assets/Megha Patro.webp'),
    },
    {
      name: 'Sambit Subhrajit Swain',
      role: 'Core Member',
      img: require('../assets/sambit subhrajit swain.webp'),
    },
    {
      name: 'Sampad Prasad Nayak',
      role: 'Core Member',
      img: require('../assets/Sampad Prasad Nayak.webp'),
    },
    {
      name: 'SN Parsuram Swain',
      role: 'Core Member',
      img: require('../assets/SN Parsuram Swain.webp'),
    },
    {
      name: 'Ayushman parida',
      role: 'Core Member',
      img: require('../assets/Ayushman parida.webp'),
    },
    {
      name: 'Dibya Shankar',
      role: 'Core Member',
      img: require('../assets/DIBYA SHANKAR.webp'),
    },
    {
      name: 'Abhishek Baral',
      role: 'Core Member',
      img: require('../assets/ABHISHEK BARAL.webp'),
    },
  ],
  
};

const MemberCard = ({ name, role, img, links }) => (
  <div className="member-card">
    <img src={img} alt={name} className="member-image" />
    <h3>{name}</h3>
    <p>{role}</p>
  </div>
);

const MembersSection = ({ title, members }) => (
  <section className="members-section">
    <h2>{title}</h2>
    <div className="members-grid">
      {members.map((m, i) => (
        <MemberCard key={i} {...m} />
      ))}
    </div>
  </section>
);

const Members = () => {
  const cursorRef = useRef(null);
  useEffect(() => {
    const move = (e) => {
      if (cursorRef.current) {
        const x = e.clientX ?? e.touches?.[0].clientX;
        const y = e.clientY ?? e.touches?.[0].clientY;
        if (x && y) {
          cursorRef.current.style.transform = `translate3d(${x - 15}px, ${y - 15}px, 0)`;
        }
      }
    };

    window.addEventListener("mousemove", move);
    window.addEventListener("touchmove", move);

    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("touchmove", move);
    };
  }, []);


  return (
    <>
    <Navbar/>
    <div className="cursor-glow" ref={cursorRef}></div>

    <div className="members-page">
      <FadeInSection>
        <MembersSection title="Faculty In-Charge" members={membersData.faculty} />
      </FadeInSection>
      <FadeInSection>
        <MembersSection title="4th Year Members" members={membersData.fourthYear} />
      </FadeInSection>
      <FadeInSection>
        <MembersSection title="3rd Year Members" members={membersData.thirdYear} />
      </FadeInSection>
    </div>
    <Footer/>
    </>
  );
};

export default Members;
